import commonApi from './apis'
// import getResponse from 'fe-coms/utils/response'
import cachedRequest from 'fe-coms/utils/cached-request'
// const http = new Vue().$http

const action = {
  async getDigits ({ commit, state }) {
    if (state.isFetching) {
      const api = commonApi.digits
      // const data = await getResponse(http(api.type, api.url, {}))
      const data = await cachedRequest(api, {})
      let obj = {
        isFetching: true
      }
      if (data.isOk) {
        obj = {
          unitPriceDigits: data.content.unitPriceBit,
          totalPriceDigits: data.content.totalPriceBit,
          numberDigits: data.content.unitNumber,
          isFetching: false
        }
      }
      commit('set_digits', obj)
    }
  }
}

export default action
